import { createMachine } from 'xstate';

import { createPayload, handleRefund, executeRefund, isManualRefund } from './actions';

const refundMachine = createMachine(
  {
    id: 'mock-refund',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'checkRefundType',
        },
      },
      checkRefundType: {
        entry: ['createPayload'],
        invoke: {
          id: 'mockRequest',
          src: isManualRefund,
          onDone: {
            target: 'loading',
          },
          onError: {
            target: 'cancelled',
          },
        },
      },
      loading: {
        invoke: {
          id: 'mockRequest',
          src: executeRefund,
          onDone: {
            target: 'success',
            actions: ['handleRefund'],
          },
          onError: {
            target: 'failure',
            actions: ['handleRefund'],
          },
        },
      },
      success: {
        type: 'final',
      },
      failure: {
        on: {
          RETRY: {
            target: 'loading',
          },
          CANCEL: {
            target: 'cancelled',
          },
        },
      },
      cancelled: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      createPayload,
      executeRefund,
      handleRefund,
      isManualRefund,
    },
  },
);

export { refundMachine };
